{
  "el": {
    "partner": {
      "actions": {
        "add": "Προσθήκη",
        "changeProfilePicture": "Αλλαγή φωτογραφίας προφίλ",
        "new": "Συνεργάτης",
        "profilePictureFormat": "Πρέπει να είναι τουλάχιστον 300x300px",
        "save": "Αποθήκευση",
        "sendinvitation": "Αποστολή πρόσκλησης",
        "submit": "Αποθήκευση",
        "undoChanges": "Αναίρεση"
      },
      "attributes": {
        "email_address": "Email",
        "email_notifications_interval": {
          "daily": "Μία φορά την ημέρα (γύρω στο μεσημέρι)",
          "hourly": "Κάθε ώρα",
          "twice_daily": "Δύο φορές την ημέρα (πρωί/μεσημέρι)",
          "weekly": "Μία φορά την εβδομάδα (Δευτέρα μεσημέρι)"
        },
        "first_name": "Όνομα",
        "internal_note": "Εσωτερική σημείωση",
        "language": "Γλώσσα",
        "last_name": "Επώνυμο",
        "phone_landline": "Αριθμός σταθερού τηλεφώνου",
        "phone_mobile": "Αριθμός κινητού τηλεφώνου",
        "profession": "Επάγγελμα",
        "session_ended_at": "Τελευταία δραστηριότητα",
        "status": "Κατάσταση",
        "title": "Τίτλος"
      },
      "labels": {
        "addExistingCompany": "Προσθήκη σε υπάρχουσα εταιρεία",
        "contactDetails": "Στοιχεία επικοινωνίας",
        "createNewCompany": "Δημιουργία νέας εταιρείας",
        "information": "Πληροφορίες προφίλ",
        "newTeamMember": "Νέος συνεργάτης",
        "notEditable": "Ορισμένα πεδία δεν είναι πλέον επεξεργάσιμα μόλις ένας συνεργάτης γίνει ενεργός",
        "partnerAddedState": "<b>Δεν έχει προσκληθεί ακόμα</b>. Ένα email πρόσκλησης θα σταλεί μόλις {partner_name} αποκτήσει πρόσβαση σε δημοσιευμένη απόφαση, παρατήρηση ή έγγραφο.",
        "selectedCompany": "Επιλεγμένη εταιρεία",
        "start_by_selecting_project": "Ξεκίνα επιλέγοντας ένα έργο στα αριστερά"
      },
      "toasts": {
        "create": "Ο συνεργάτης δημιουργήθηκε",
        "update": "Ο συνεργάτης ενημερώθηκε"
      },
      "validation": {
        "mustBeEmailAddress": "Απαιτείται έγκυρη διεύθυνση email",
        "needFirstName": "Το όνομα είναι υποχρεωτικό",
        "needLastName": "Το επώνυμο είναι υποχρεωτικό",
        "requireEmailAddress": "Το email είναι υποχρεωτικό"
      }
    }
  }
}
